import { Component, OnInit } from '@angular/core';

import { Pros } from 'src/providers/pros/pros';
import { Client } from 'src/providers/client/client';
import { OnboardingProvider } from 'src/providers/onboarding/onboarding.provider';

import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { WindowService } from 'src/shared/providers/window.service';
import { Util } from 'src/shared/util/util';
import { OnboardingComponent } from 'src/shared/components/onboarding/onboarding';

@Component({
    selector: 'select-find-new-pros-option-onboarding',
    templateUrl: './select-find-new-pros-option-onboarding.html',
    styleUrls: ['./select-find-new-pros-option-onboarding.scss'],
    standalone: false
})
export class SelectFindNewProsOptionOnboarding implements OnInit {
  enableFindNewPros = false;


  boundSubmit = this.submit.bind(this);

constructor(
    public onboardingProvider: OnboardingProvider,
    private client: Client,
    private util: Util,
    private prosProvider: Pros,
    private rightSidePanelService: RightSidePanelService,
    public windowService: WindowService
  ) {}

  async ngOnInit() {
    this.rightSidePanelService.setDialogPageTitle('Find New Pros');
    const metadata = await this.client.getMetadata(['external.enableFindNewPros']);
    this.enableFindNewPros = metadata?.[0]?.value || false;
  }

  async submit() {
    try {
      const serviceTypes = await this.prosProvider.getServiceCategories();
      const addresses = await this.client.getAddresses(true);
      const payload = {
        settings: serviceTypes.map((serviceType) => ({
          address_ids: addresses.map((address) => address.id),
          enabled: this.enableFindNewPros,
          service_type_id: serviceType.id,
        })),
      };
      await Promise.all([
        this.prosProvider.setFindNewPros(payload),
        this.client.addMetadata({
          key: 'enableFindNewPros',
          value: this.enableFindNewPros,
        }),
        this.onboardingProvider.markGoalAsCompleted('selectFindNewPros')
      ]);
      this.rightSidePanelService.setDialogPageTitle('Getting Started');
      this.rightSidePanelService.navigateTo('onboarding', {}, OnboardingComponent);
      this.onboardingProvider.setShowOnboardingInHeader(true);
      this.util.showSuccess('Find new pros settings saved succesfully');
    } catch (err) {
      this.util.showError((err.error && err.error.message) ? err.error.message : err.message, 10000);
    }
  }
}
